$(function () {
    function handleResize () {
        const buttons = document.querySelectorAll('.jobs-btn')
        const width = window.innerWidth
        if (width <= 768) {
            buttons.forEach(button => (button.textContent = 'Смотреть'))
        } else {
            buttons.forEach(
                button => (button.textContent = 'Смотреть вакансию')
            )
        }
    }

    window.addEventListener('load', handleResize)
    window.addEventListener('resize', handleResize)
})
